import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function NoteIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
    >
      <g id="Notes" transform="translate(-3 -3)">
        <path
          id="Caminho_10332"
          data-name="Caminho 10332"
          d="M17.222,4.778v8H12.778v4.444h-8V4.778H17.222m0-1.778H4.778A1.783,1.783,0,0,0,3,4.778V17.222A1.783,1.783,0,0,0,4.778,19h8.889L19,13.667V4.778A1.783,1.783,0,0,0,17.222,3ZM11,12.778H6.556V11H11Zm4.444-3.556H6.556V7.444h8.889Z"
          fill={color || "#333"}
        />
      </g>
    </svg>
  );
}
